export default __webpack_public_path__ + "static/media/expand_more_black_24dp.1afc4c76.svg";